/* SkyDrift — bloc d'achat : galerie, choix de variante, paliers de lot.
   Tout part du JSON que Liquid a posé dans la section : pas de prix en dur,
   pas de format de devise deviné cote client. */
(function () {
  const section = document.querySelector("[data-skydrift-achat]");
  if (!section) return;

  /* ---------------------------------------------------------- galerie */
  const piste = section.querySelector("[data-piste]");
  const vues = piste ? Array.from(piste.children) : [];
  // partagee avec le choix de variante : choisir un modele doit montrer ce modele
  let versVue = null;
  // identifiant de media -> rang dans la galerie. On ne se fie pas a un numero
  // de position : ajouter un visuel ou une video decale tout, l'identifiant non.
  const rangDuMedia = {};
  const rangDeLApercu = {};

  if (vues.length > 1) {
    const points = section.querySelector("[data-points]");
    const compteur = section.querySelector("[data-compteur]");
    let index = 0;

    vues.forEach((_, i) => {
      const pastille = document.createElement("button");
      pastille.type = "button";
      pastille.className = "gal-dot";
      pastille.setAttribute("aria-label", "Vue " + (i + 1));
      pastille.addEventListener("click", () => aller(i));
      points && points.appendChild(pastille);
    });

    const aller = i => {
      index = (i + vues.length) % vues.length;
      piste.style.transform = "translateX(" + index * -100 + "%)";
      if (points) Array.from(points.children).forEach((d, n) => d.classList.toggle("is-on", n === index));
      if (compteur) compteur.textContent = index + 1 + " / " + vues.length;
      // une video hors champ qui continue de tourner, c'est de la batterie pour rien
      vues.forEach((vue, n) => {
        const film = vue.querySelector("video");
        if (!film) return;
        if (n === index) film.play().catch(() => {});
        else film.pause();
      });
    };

    versVue = aller;
    vues.forEach((vue, i) => {
      if (vue.dataset.media) rangDuMedia[vue.dataset.media] = i;
      if (vue.dataset.apercu) rangDeLApercu[vue.dataset.apercu] = i;
    });
    section.querySelector("[data-prec]").addEventListener("click", () => aller(index - 1));
    section.querySelector("[data-suiv]").addEventListener("click", () => aller(index + 1));

    section.querySelector(".gal-stage").addEventListener("keydown", e => {
      if (e.key === "ArrowLeft") aller(index - 1);
      if (e.key === "ArrowRight") aller(index + 1);
    });

    let departX = null;
    const scene = section.querySelector(".gal-stage");
    scene.addEventListener("touchstart", e => { departX = e.touches[0].clientX; }, { passive: true });
    scene.addEventListener("touchend", e => {
      if (departX === null) return;
      const delta = e.changedTouches[0].clientX - departX;
      if (Math.abs(delta) > 45) aller(delta < 0 ? index + 1 : index - 1);
      departX = null;
    }, { passive: true });

    aller(0);
  }

  /* -------------------------------------------------------- variantes */
  const brut = section.querySelector("[data-variantes]");
  const variantes = brut ? JSON.parse(brut.textContent) : [];
  const champVariante = section.querySelector("[data-variante]");
  const champPrix = section.querySelector("[data-prix]");
  const champBarre = section.querySelector("[data-prix-barre]");
  const bouton = section.querySelector(".p-cta");
  const paliers = section.querySelector("[data-paliers]");
  const listes = Array.from(section.querySelectorAll("[data-coul]"));
  let choix = [];

  if (listes.length && variantes.length) {
    // Rien n'est choisi au depart : on ne veut pas qu'un client reparte avec
    // le coloris par defaut sans l'avoir vu. Le bouton reste bloque jusque-la.
    const combien = (variantes[0].options || []).length;
    choix = new Array(combien).fill(null);
    bouton.dataset.libelle = bouton.textContent.trim();

    const trouve = () => variantes.find(v => v.options.every((o, i) => o === choix[i]));

    const ferme = sauf => listes.forEach(c => {
      if (c === sauf) return;
      c.querySelector("[data-liste]").hidden = true;
      c.querySelector("[data-ouvre]").setAttribute("aria-expanded", "false");
    });

    const rafraichit = () => {
      listes.forEach(c => {
        const pos = Number(c.dataset.option) - 1;
        const actuel = choix[pos];
        const pastille = c.querySelector("[data-pastille]");
        const etiquette = c.querySelector("[data-actuel]");

        c.querySelectorAll(".coul-item").forEach(item => {
          const v = item.dataset.valeur;
          item.classList.toggle("is-on", v === actuel);
          item.closest("li").setAttribute("aria-selected", v === actuel);
          // un coloris qu'aucune variante en stock ne porte se voit tout de suite
          const test = choix.slice();
          test[pos] = v;
          const cible = variantes.find(x => x.options.every((o, i) => o === test[i]));
          item.classList.toggle("is-out", !cible || !cible.dispo);
          if (actuel !== null && v === actuel) {
            if (etiquette) etiquette.textContent = v;
            if (pastille) pastille.style.background = item.dataset.teinte || "";
          }
        });
      });

      const manque = choix.some(c => c === null);
      if (manque) {
        const premier = listes.find(c => choix[Number(c.dataset.option) - 1] === null);
        const quoi = premier.querySelector("[data-ouvre]").dataset.invite || "Choisir";
        bouton.disabled = true;
        bouton.textContent = quoi.replace(/^Choisir/, "Choisissez");
        return;
      }

      const v = trouve();
      if (!v) { bouton.disabled = true; bouton.textContent = "Indisponible"; return; }
      champVariante.value = v.id;
      if (champPrix) champPrix.textContent = v.prixTexte;
      if (champBarre) {
        champBarre.textContent = v.barreTexte || "";
        champBarre.hidden = !v.barreTexte;
      }
      if (paliers) { paliers.dataset.prixUnitaire = v.prix; dessinePaliers(); }
      // la galerie saute sur le visuel de la variante choisie
      // deux repères : l'identifiant du media, sinon l'adresse de l'image
      let rang = rangDuMedia[v.media];
      if (rang === undefined && v.apercu) rang = rangDeLApercu[v.apercu];
      if (versVue && rang !== undefined) versVue(rang);
      bouton.disabled = !v.dispo;
      bouton.textContent = v.dispo ? bouton.dataset.libelle : "Épuisé";

      // l'URL suit la variante : un lien partage rouvre le bon coloris
      const url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      window.history.replaceState({}, "", url);
    };

    listes.forEach(c => {
      const ouvre = c.querySelector("[data-ouvre]");
      const liste = c.querySelector("[data-liste]");
      ouvre.addEventListener("click", e => {
        e.stopPropagation();
        const ouvert = !liste.hidden;
        ferme(null);
        liste.hidden = ouvert;
        ouvre.setAttribute("aria-expanded", String(!ouvert));
      });
      c.querySelectorAll(".coul-item").forEach(item => {
        item.addEventListener("click", e => {
          e.stopPropagation();
          choix[Number(item.dataset.option) - 1] = item.dataset.valeur;
          liste.hidden = true;
          ouvre.setAttribute("aria-expanded", "false");
          rafraichit();
        });
      });
    });

    // un clic ailleurs, ou Echap, referme la liste
    document.addEventListener("click", () => ferme(null));
    document.addEventListener("keydown", e => { if (e.key === "Escape") ferme(null); });

    rafraichit();
  }

  /* ------------------------------------------------------ lot / volume */
  function dessinePaliers() {
    if (!paliers) return;
    const unitaire = Number(paliers.dataset.prixUnitaire);
    const remises = [0].concat(paliers.dataset.remises.split(",").map(Number));
    const argent = new Intl.NumberFormat(paliers.dataset.langue || "fr", {
      style: "currency",
      currency: paliers.dataset.devise || "EUR"
    });
    const champQuantite = section.querySelector("[data-quantite]");
    const actif = Number(champQuantite ? champQuantite.value : 1);

    paliers.innerHTML = "";
    remises.forEach((remise, i) => {
      const n = i + 1;
      // palier : la remise porte sur toutes les voitures du lot. Shopify
      // l'arrondit au centime inferieur sur chaque voiture, on fait pareil.
      const total = n * (unitaire - Math.floor(unitaire * remise / 100));

      const plein = unitaire * n;
      const ligne = document.createElement("button");
      ligne.type = "button";
      ligne.className = "pick" + (n === actif ? " is-on" : "");
      ligne.setAttribute("role", "radio");
      ligne.setAttribute("aria-checked", n === actif);
      ligne.innerHTML =
        (remises[i] ? '<span class="pick-flag">\u2212' + remises[i] + "&nbsp;%</span>" : "") +
        '<span class="pick-label">' + n + (n > 1 ? " voitures" : " voiture") + "</span>" +
        '<span class="pick-total">' + argent.format(total / 100) + "</span>" +
        '<span class="pick-save">' +
          (plein > total ? "vous \u00e9conomisez " + argent.format((plein - total) / 100) : "&nbsp;") +
        "</span>";
      ligne.addEventListener("click", () => {
        if (champQuantite) champQuantite.value = n;
        dessinePaliers();
      });
      paliers.appendChild(ligne);
    });
  }
  dessinePaliers();
})();
